//Types
export const Types = {
  INGESTOR_STATISTICS: "INGESTOR_STATISTICS",
  SET_LOADING: "SET_LOADING_STATISTICS",
}

//Reducer
const initialState = {
  ingestorStatistics: null,
  loading: false,
}

const IngestorMonitoring = (state = initialState, action) => {
  switch (action.type) {
    case Types.INGESTOR_STATISTICS:
      return {
        ...state,
        ingestorStatistics: action.payload,
        loading: false,
      }
    case Types.SET_LOADING:
      return {
        ...state,
        loading: true
      }

    default:
      return state;
  }
}

export default IngestorMonitoring;
